import axios from "axios";
import router from "@/router";

const state = () => ({
  myAxios: axios.create({
    // baseURL: `https://wec.koiote.es:4002`,
    baseURL: `${process.env.VUE_APP_PROTOCOL}://${process.env.VUE_APP_BACK_HOST}:${process.env.VUE_APP_BACKEND_PORT}`,
    headers: {
      "Content-Type": "application/json",
      common: {
        Authorization: "Bearer " + localStorage.getItem("token") || null,
      },
    },
  }),
  user: {},
});
const getters = {};
const mutations = {};

const actions = {
  setUpInterceptors({ state }) {
    state.myAxios.interceptors.request.use(
      function (config) {
        let token = localStorage.getItem("token");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
        } else {
          if (router.currentRoute.name != "login") this.dispatch("api/logout");
        }
        return config;
      },
      function (err) {
        return Promise.reject(err);
      }
    );
    state.myAxios.interceptors.response.use(
      (response) => {
        // If the response status is between 200 and 299, it's a successful response, so return it as is.
        return response;
      },
      (error) => {
        if (error.response && error.response.status === 413) {
          //console.error('Payload Too Large (413) - The server refused to process the request due to large payload.');
        } else if (error.response && error.response.status === 401) {
          if (router.currentRoute.name != "login") this.dispatch("api/logout");
        } else if (error.response && error.response.status === 400) {
          console.warn(
            "HA HABIDO UN ERROR EN AXIOS: ",
            error.response.data.msg ? error.response.data.msg : error.response
          );
        }
        // return Promise.reject(error);
      }
    );
  },
  setUser({ state }, user) {
    state.user = user;
    // localStorage.setItem('user', JSON.stringify({user_id:1, role_name:'admin'}))
    localStorage.setItem("user", JSON.stringify(user));
  },
  setToken(token) {
    localStorage.setItem("token", token);
  },

  //    LOGIN & LOGOUT
  async login({ state }, userInfo) {
    try {
      const res = await state.myAxios.post("api/auth/login", userInfo);
      if (res.data) {
        this.dispatch("api/setToken", res.data.token);
        let user = {
          user_id: res.data.user_id,
          username: res.data.username,
          role_name: res.data.role_name,
          plantas: res.data.plantas,
        };
        this.dispatch("api/setUser", user);

        if (res.data.role_name == "admin") {
          this.dispatch("setRol", 1);
          this.dispatch("setIsPlayMode", false);
          this.dispatch("setIsAdmin", true);
        } else {
          if (res.data.role_name == "avanzado") this.dispatch("setRol", 2);
          else this.dispatch("setRol", 3);
          this.dispatch("setIsPlayMode", true);
          this.dispatch("setIsAdmin", false);
        }
      } else {
        console.log("Problema al loggearse");
      }
    } catch (error) {
      return error;
    }
  },
  logout({ state }) {
    state.user = {};
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    localStorage.removeItem("clienteSeleccionado")
    router.push({ path: "login" }).catch(() => {});
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
